import { Component, ReactElement } from 'react';

export const wrapIfString = (
  input: string | ReactElement,
  Wrapper: string | typeof Component,
): ReactElement => {
  if (typeof input === 'string') {
    return <Wrapper>{input}</Wrapper>;
  }

  return input;
};

export default wrapIfString;
